import Icon from 'vue-awesome';

export default {
  props: {},
  components: {
    Icon,
  },
  data() {
    return {
      menues: [
        // {
        //   name: this.$t('base.dashboard'),
        //   routeName: 'home.index',
        //   icon: 'tachometer',
        //   isLeaf: false,
        // },
        {
          name: this.$t('order.order'),
          routeName: 'order.index',
          icon: 'shopping-cart',
          isLeaf: true,
          subMenu: [
            {
              name: this.$t('order.orderCreate'),
              icon: 'plus',
              routeName: 'order.create',
            },
            {
              name: this.$t('order.view'),
              icon: 'list',
              routeName: 'order.view',
            },
          ],
        },
        {
          name: this.$t('product.product'),
          routeName: 'product.index',
          icon: 'archive',
          isLeaf: true,
          subMenu: [
            {
              name: this.$t('product.productEdit'),
              icon: 'archive',
              routeName: 'product.view',
            },
          ],
        },
        {
          name: this.$t('base.wordboard'),
          routeName: 'wordboard.index',
          icon: 'bars',
          isLeaf: false,
        },

        {
          name: this.$t('customer.customer'),
          routeName: 'customer.index',
          icon: 'users',
          isLeaf: true,
          subMenu: [
            {
              name: this.$t('customer.customerEdit'),
              icon: 'user',
              routeName: 'customer.view',
            },
            {
              name: this.$t('customer.group'),
              icon: 'users',
              routeName: 'customer.group',
            },
          ],
        },

        {
          name: this.$t('user.user'),
          routeName: 'user.index',
          icon: 'male',
          isLeaf: true,
          subMenu: [
            {
              name: this.$t('user.view'),
              icon: 'user',
              routeName: 'user.view',
            },
          ],
        },
      ],
    };
  },
  methods: {
    navigate(name) {
      this.$router.push({ name: name });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js